import { IcoCog, IcoFileText, IcoUsers } from "../icons";

type OrgTabsProps = {
  orgId: string;
  activeTab: "activity" | "members" | "forms" | "settings";
  memberCount?: number;
  formCount?: number;
};

export function OrgTabs({
  orgId,
  activeTab,
  memberCount,
  formCount,
}: OrgTabsProps) {
  return (
    <div class="flex items-center gap-1 border-b border-border -mx-1">
      <TabLink
        href={`/orgs/${orgId}`}
        active={activeTab === "activity"}
        label="Activity"
      />
      <TabLink
        href={`/orgs/${orgId}/members`}
        active={activeTab === "members"}
        label="Members"
        count={memberCount}
        icon={<IcoUsers class="size-4" />}
      />
      <TabLink
        href={`/orgs/${orgId}/forms`}
        active={activeTab === "forms"}
        label="Forms"
        count={formCount}
        icon={<IcoFileText class="size-4" />}
      />
      <TabLink
        href={`/orgs/${orgId}/settings`}
        active={activeTab === "settings"}
        label="Settings"
        icon={<IcoCog class="size-4" />}
      />
    </div>
  );
}

function TabLink({
  href,
  active,
  label,
  count,
  icon,
}: {
  href: string;
  active: boolean;
  label: string;
  count?: number;
  icon?: preact.JSX.Element;
}) {
  return (
    <a
      href={href}
      class={`inline-flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors rounded-none focus-visible:rounded ${
        active
          ? "text-text border-text"
          : "text-text-muted hover:text-text border-transparent"
      }`}
    >
      {icon}
      {label}
      {count !== undefined && (
        <span
          class={`text-xs ${active ? "text-text-muted" : "text-text-subtle"}`}
        >
          ({count})
        </span>
      )}
    </a>
  );
}
